import React from 'react'

export default function HeroSection() {
  return (
    <div className=' w-full flex flex-col lg:space-y-8 space-y-8 px-4 lg:justify-center py-20 items-center h-screen z-10'>

<p className=' lg:text-5xl text-3xl font-bold '>
<span className='text-white'>
    Perfect for </span><span className=' text-[#E84C61]  rounded-full mx-2 border-[#2C2F3C] lg:px-4 lg:py-2 px-2 py-0.5 border-2'>Education </span><span className='text-[#F8B81F]'>& </span><span className=' text-[#28B889]  rounded-full mx-2 border-[#2C2F3C] lg:px-4 lg:py-2 px-2 py-0.5 border-2'>Online </span><span className=' text-white'>Diverse Content</span>
</p>
<p className=' lg:text-5xl text-3xl font-bold text-white'>
Innovative Software
</p>

<p className=' text-lg text-white font-semibold'>AI <span className=' text-[#9A9DA3]'>Question Generation Models</span>, Online Compiler and Encrypted Chat groups and bunch of notes <span className=' text-[#9A9DA3]'>For All</span></p>

    </div>
  )
}
